import * as React from "react";

function IconCurrencyLeu({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-currency-leu" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/currency-leu"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M17 18h-7a3 3 0 0 1 -3 -3v-10" /></svg>;
}

export default IconCurrencyLeu;